// extracted by mini-css-extract-plugin
module.exports = {"container":"DecorativeLink_container__3KoyT","container--black":"DecorativeLink_container--black__foggN"};